import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useBoolean, useRecentGetter } from '@lib/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSubject } from '@lib/common/hooks/use-subject';
import { CompanyMasters } from '@api/masters';
import fuzzysort from 'fuzzysort';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { debounceTime, switchMap } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';
import { ServiceDialogContent } from './ServiceDialogContent';

export const ServicesPicker = ({
  services,
  open = false,
  onServiceAdd = null,
}: {
  services: CompanyMasters.Service[];
  open: boolean;
  onServiceAdd?: (service: CompanyMasters.Service) => any;
}) => {
  const [serviceOptions, setServiceOptions] = useState<
    Array<CompanyMasters.Service & { highlighted?: string }>
  >(
    // useMemo(() => (services.push({ id: 835, service: 'Others' }), services), [])
    services
  );
  //Masters doesnt result others

  useEffect(() => {
    setServiceOptions(services);
  }, [services]);

  const [dialogOpen, openDialog, closeDialog] = useBoolean(false);

  useEffect(() => {
    if (open) {
      openDialog();
    }
  }, [open]);
  const searchTargets = useMemo(
    () => services.map(s => ({ ...s, prepared: fuzzysort.prepare(s.service) })),
    [services]
  );

  const resetResults = () => {
    setServiceOptions(services);
  };

  const state = useRecentGetter({ searchTargets, setServiceOptions, serviceOptions, resetResults });

  const search$ = useSubject<string>();

  useSubscription(() =>
    search$
      .pipe(
        debounceTime(300, asyncScheduler),
        switchMap(txt =>
          !txt.trim()
            ? Promise.resolve(null)
            : fuzzysort.goAsync(txt, state().searchTargets, {
                key: 'prepared',
                limit: 50,
                threshold: -1000,
              })
        )
      )
      .subscribe(results => {
        if (!results) {
          return state().resetResults();
        }

        state().setServiceOptions(
          results.map(r => ({
            ...r.obj,
            highlighted: fuzzysort.highlight(r, '<strong>', '</strong>'),
          }))
        );
      })
  );

  const onSearch = useCallback(
    evt => {
      search$.next(evt.target.value);
    },
    [search$]
  );

  const handleServiceClick = useCallback(
    (srv: CompanyMasters.Service) => () => {
      closeDialog();
      setTimeout(() => {
        onServiceAdd && onServiceAdd({ id: srv.id, service: srv.service });
      }, 100);
    },
    [closeDialog, onServiceAdd]
  );

  return (
    <>
      {/* <Button onClick={openDialog} color="primary" variant="contained">
        Add
      </Button> */}
      <Dialog
        // Disable transitions to speed up the element interaction
        // and fix multiple addtion on consecutive clicks.
        transitionDuration={0}
        fullWidth
        maxWidth="xs"
        open={dialogOpen}
        onClose={closeDialog}>
        <DialogTitle>Browse Services</DialogTitle>
        <DialogContent style={{ height: '65vh' }} dividers>
          <ServiceDialogContent
            serviceOptions={serviceOptions}
            servicesLength={services.length}
            onSearch={onSearch}
            handleServiceClick={handleServiceClick}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
